const trimTrailingSlash = (value) => String(value || '').replace(/\/$/, '');

export const DASHBOARD_URL = trimTrailingSlash(
  process.env.REACT_APP_DASHBOARD_URL || 'https://dashboard.mailsnappy.com'
);

export const API_BASE = trimTrailingSlash(
  process.env.REACT_APP_API_BASE || 'https://backend.mailsnappy.com/api'
    // process.env.REACT_APP_API_BASE || 'http://localhost:8001/api'

);

export function dashboardUrl(path = '') {
  const normalizedPath = path ? `/${String(path).replace(/^\//, '')}` : '';
  return `${DASHBOARD_URL}${normalizedPath}`;
}
